import { Link } from "react-router-dom";

const Footer = () => {
  // Define logo image metadata
  const logoImage = {
    src: "/images/logo/mobile-detail-co-logo.png",
    alt: "Mobile Detail Co. Logo - Professional Auto Detailing Services",
    width: 400,
    height: 120
  };

  return (
    <footer className="bg-primary py-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center md:text-left">
            <img
              src={logoImage.src}
              alt={logoImage.alt}
              width={logoImage.width}
              height={logoImage.height}
              loading="lazy"
              className="h-16 w-auto object-contain mx-auto md:mx-0 mb-4"
            />
            <p className="text-white">Professional Mobile Detailing Services</p>
          </div>
          <div className="text-center">
            <h3 className="text-lg font-semibold text-white mb-4">Quick Links</h3>
            <nav className="space-y-2">
              <Link to="/" className="block text-white hover:text-primary-light">Home</Link>
              <Link to="/services" className="block text-white hover:text-primary-light">Services</Link>
              <Link to="/gallery" className="block text-white hover:text-primary-light">Gallery</Link>
              <Link to="/contact" className="block text-white hover:text-primary-light">Contact</Link>
            </nav>
          </div>
          <div className="text-center md:text-right">
            <h3 className="text-lg font-semibold text-white mb-4">Contact Us</h3>
            <p className="text-white">Phone: (651) 286-9930</p>
            <p className="text-white">Email: support@mobiledetailco.com</p>
          </div>
        </div>
        <div className="text-center mt-8 pt-4 border-t border-primary-light">
          <p className="text-white">&copy; {new Date().getFullYear()} Mobile Detail Co. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
